import { sumAndFindMax } from "pages/private/ResumeRoute/ResumenRouteDiscounts";




/**
 * Funcion que obtienes los viajes ida y vuelta  y unifican lo que solo trenes en uno
 */
export function getTransportDiscounts(departureTrip: any,arrivalTrip:any,t:any) {

    let  isRoundTripAux=false;
    let transportsIda=departureTrip?.summaryAmount?.departure?.transports?.filter((i: any) => i?.transport!="Cooltra" && i?.transport!="Tier" && i?.informative===false && i?.icon!='ave'&& i?.icon!='cercanias' && i?.isPaidTrip===false )|| [];
    const transportsIdaOnlyTrain=departureTrip?.summaryAmount?.departure?.transports?.filter((i: any) =>( i?.icon=='ave'|| i?.icon=='cercanias') && i?.informative===false && i?.bonoAveFree===false && i?.isPaidTrip===false  )|| [];
    let transportsVuelta=arrivalTrip?.summaryAmount?.arrival?.transports?.filter((i: any) => i?.transport!="Cooltra"&& i?.transport!="Tier" && i?.informative===false && i?.icon!='ave'&& i?.icon!='cercanias' && i?.isPaidTrip===false )||  [];
    const transportsVueltaOnlyTrain=arrivalTrip?.summaryAmount?.arrival?.transports?.filter((i: any) => (i?.icon=='ave'|| i?.icon=='cercanias') && i?.informative===false && i?.bonoAveFree===false && i?.isPaidTrip===false  )|| [];


    //Tengo ambas array de trenes rellena la unifico todos los trenes en la ida
  if((transportsIdaOnlyTrain&& (transportsIdaOnlyTrain.length!=0)) && (transportsVueltaOnlyTrain&&(transportsVueltaOnlyTrain.length!=0)) ){
  const concatenatedArray = transportsIdaOnlyTrain.concat(transportsVueltaOnlyTrain);
  isRoundTripAux=true;
  transportsIda.push(sumAndFindMax(concatenatedArray,t)[0])

 //Tengo viajes de ida con trenes ?
  }else if((transportsIda &&(transportsIdaOnlyTrain&& (transportsIdaOnlyTrain.length!=0)))  && (transportsVueltaOnlyTrain&&(transportsVueltaOnlyTrain.length===0))){
  transportsIda.push(sumAndFindMax(transportsIdaOnlyTrain,t)[0])
  //Tengo viajes y trenes
  }else if(transportsIda.length!==0 && (transportsIdaOnlyTrain&& (transportsIdaOnlyTrain.length!=0))){
  transportsIda.push(sumAndFindMax(transportsIdaOnlyTrain,t)[0])
  }else if(transportsVueltaOnlyTrain&&(transportsVueltaOnlyTrain.length!=0)){
    isRoundTripAux=true;
  transportsIda.push(sumAndFindMax(transportsVueltaOnlyTrain,t)[0])
  //Si solo tenemos trenes en ida y no viajes normales
  }else if(transportsIda.length===0 &&transportsIdaOnlyTrain.length!=0){
    transportsIda.push(sumAndFindMax(transportsIdaOnlyTrain,t)[0])
  }
  else if(transportsVuelta.length===0 &&transportsVueltaOnlyTrain.length!=0){
    isRoundTripAux=true;
    transportsIda.push(sumAndFindMax(transportsVueltaOnlyTrain,t)[0])
  }

  if(transportsIda.length!=0 && transportsVuelta.length!=0 ){
    isRoundTripAux=true;
  }

  return{transportsIda,transportsVuelta,isRoundTripAux}

}



export function getTypeTripAndPst(departureTrip: any,arrivalTrip:any,key:any,transports:any,idLeg:any) {
    let getTotal
    let bodyPost;
    let type

    if(key==="departure"){
        type={type:'departure'}
        getTotal=departureTrip?.summaryAmount?.departure?.desglose?.total;
        bodyPost=departureTrip
      }else{
        type={type:'arrival'}
        getTotal=arrivalTrip?.summaryAmount?.arrival?.desglose?.total;
        bodyPost=arrivalTrip
      }
    
     

      let filter = transports.find((item: any) => item.idLeg === idLeg.toString() && item?.key===key);


      return{getTotal,bodyPost,type,filter}
}

